/*
 * DD AdminUI
 * Copyright (C) Fraunhofer IESE 2019 - 2025 Stefan Schweitzer, Shyalan Ramesh, Rafael Aranda López King,
 * Florian Wege, Johannes Schneider, Kazi Rezoanur Rahman, Christoph Müller, Pedram Jokar,
 * Mher Ter-Tovmasyan, Ben Burkhard, Matthias Gerbershagen, Anna Kleiner, Muhammad Tariq,
 * Adeline Silva Schäfer
 *
 * SPDX-License-Identifier: Apache-2.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { FormHelperText, Grid, Theme, useMediaQuery, useTheme } from '@mui/material';
import { ClientPersonExtended, ClientPersonOwn } from '@DigitaleDoerfer/digitale-doerfer-api';
import AvatarView from '../Avatar.view';
import { ImageSizes } from '../../services/Image.service';
import { ReadOnlyTextFieldView } from '../ReadOnlyTextField.view';

export interface Props {
	user: ClientPersonExtended | ClientPersonOwn;
}

export function PersonNameWithAvatarPictureFormView(props: Props): JSX.Element {
	const { user } = props;
	const theme: Theme = useTheme();
	const { firstName, lastName, profilePicture, deleted } = user;
	const isSmallBreakPoint = useMediaQuery(theme.breakpoints.down('md'));
	const dorfFunkName =
		firstName || lastName
			? `Im DorfFunk angezeigt als ${firstName ?? ''}${lastName ? ` ${lastName.charAt(0)}` : ''}.`
			: '';
	const avatarGridView = (
		<Grid item md={6}>
			<AvatarView avatarPicture={profilePicture} deleted={deleted} size={ImageSizes.MEDIUM} />
		</Grid>
	);
	return (
		<>
			{isSmallBreakPoint ? avatarGridView : ''}
			<Grid item container spacing={3} md={6}>
				<Grid item xs={12}>
					<ReadOnlyTextFieldView
						id="firstName"
						name="firstName"
						label="Vorname"
						value={firstName ?? ''}
						InputProps={{ readOnly: true }}
						InputLabelProps={{
							shrink: true
						}}
						fullWidth
					/>
				</Grid>
				<Grid item xs={12}>
					<ReadOnlyTextFieldView
						id="lastName"
						name="lastName"
						label="Nachname"
						value={lastName ?? ''}
						InputProps={{ readOnly: true }}
						InputLabelProps={{
							shrink: true
						}}
						fullWidth
					/>
					<FormHelperText>{dorfFunkName}</FormHelperText>
				</Grid>
			</Grid>
			{isSmallBreakPoint ? '' : avatarGridView}
		</>
	);
}
export default PersonNameWithAvatarPictureFormView;
